import React from 'react';
import PropTypes from 'prop-types';
const StatusDisplayWidget = ({ value }) => (
  <div className="">
    {value && <div className="alert alert-info">Current value: {value}</div>}
  </div>
);

StatusDisplayWidget.propTypes = {
  value: PropTypes.string
};

export default StatusDisplayWidget;



// WEBPACK FOOTER //
// ./src/components/StatusDisplayWidget.js